import api from '@/api/sourceCode'

const state = {

}

const actions = {
  getCompanySourceCode (context, params) {
    return api.getCompanySourceCode(params)
  },
  getSourceChannelList (context, params) {
    return api.getSourceChannelList(params)
  },
  updateSourceChannelStatus (context, data) {
    return api.updateSourceChannelStatus(data)
  },
  saveSourceChannel (context, data) {
    return api.saveSourceChannel(data)
  },
  getSourceCodeList (context, params) {
    return api.getSourceCodeList(params)
  },
  getSourceCodeById (context, { sourceCodeId, params }) {
    return api.getSourceCodeById(sourceCodeId, params)
  },
  updateSourceCodeById (context, { sourceCodeId, data }) {
    return api.updateSourceCodeById(sourceCodeId, data)
  },
  saveSourceCode (context, data) {
    return api.saveSourceCode(data)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
